import script from "./ProductDetailRichText.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailRichText.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailRichText.vue?vue&type=style&index=0&id=78ba8136&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ba8136"]])

export default __exports__